// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-e1578ada] .badge.badge-pill{font-size:14px;padding:.75rem 1.5rem}.not-valid~.invalid-feedback[data-v-e1578ada]{display:block;text-align:left;padding-left:1rem;margin-top:-1rem}.multi-select-container[data-v-e1578ada]{display:flex;gap:40px}@media(max-width:575px){.multi-select-container[data-v-e1578ada]{display:block}}.p-3[data-v-e1578ada]{padding:0!important}", ""]);
// Exports
module.exports = exports;
